import {Presenter} from '../../../support/with_presenter';
import {map, Observable, Subscription} from 'rxjs';
import {MediaItem} from '../../../models/MediaItem';

export interface MediaItemInteractor {
    mediaItems: Observable<MediaItem[]>;

    add(mediaItem: MediaItem): void;

    delete(mediaItem: MediaItem): void;
}

export class MediaItemListPresenter implements Presenter {
    public addMediaItemWizardVisible = false;

    public mediaItems: MediaItem[] = [];

    private subscription: Subscription | undefined;

    constructor(private expandedPartUuid: string, private mediaItemInteractor: MediaItemInteractor) {}

    public mount(): void {
        this.subscription = this.mediaItemInteractor.mediaItems
            .pipe(
                map((mediaItems) =>
                    mediaItems.filter((mediaItem) => mediaItem.anchor.__expandedPartUuid === this.expandedPartUuid),
                ),
            )
            .subscribe((mediaItems) => (this.mediaItems = mediaItems));
    }

    public unmount(): void {
        this.subscription?.unsubscribe();
    }

    public onAddMediaItemClick() {
        this.addMediaItemWizardVisible = true;
    }

    public onCancelAddMediaItemWizard() {
        this.addMediaItemWizardVisible = false;
    }

    public onAddMediaItem(mediaItem: MediaItem) {
        this.mediaItemInteractor.add(mediaItem);
        this.addMediaItemWizardVisible = false;
    }

    public onTrashMediaItem(mediaItem: MediaItem) {
        this.mediaItemInteractor.delete(mediaItem);
    }
}
